import React, { useState } from "react";
import {
  Select,
  FormControl,
  Text,
  Input,
  Button,
  Box,
} from "@chakra-ui/react";
// import firestore from "@react-native-firebase/firestore";
// import { Calendar, LocaleConfig } from "react-native-calendars";
import moment from "moment-timezone";
// import { ScrollView } from "react-native";
import { colors, fonts, fontsSize } from "./styles";
// import Input from "../../components/Input";
// import Button from "../../components/Button";
// import auth from "@react-native-firebase/auth";
import "moment/locale/pt-br";
// import { isTimeBetween } from "./utils/functions";
import firebase from "./config/firebase";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import InputMask from "react-input-mask";
import MaterialInput from "@material-ui/core/Input";
moment.locale("pt-br");

// LocaleConfig.locales["pt"] = {
//   monthNames: [
//     "Janeiro",
//     "Fevereiro",
//     "Março",
//     "Abril",
//     "Maio",
//     "Junho",
//     "Julho",
//     "Agosto",
//     "Setembro",
//     "Outubro",
//     "Novembro",
//     "Dezembro",
//   ],
//   monthNamesShort: [
//     "Jan.",
//     "Fev.",
//     "Mar.",
//     "Abril",
//     "Mai.",
//     "Jun.",
//     "Jul.",
//     "Ago.",
//     "Set.",
//     "Out.",
//     "Nov.",
//     "Dez.",
//   ],
//   dayNames: [
//     "Domingo",
//     "Segunda",
//     "Terça",
//     "Quarta",
//     "Quinta",
//     "Sexta",
//     "Sábado",
//   ],
//   dayNamesShort: ["Dom.", "Seg.", "Ter.", "Qua.", "Qui.", "Sex.", "Sab."],
//   today: "Hoje",
// };

// LocaleConfig.defaultLocale = "pt";

const CreateSchedule = () => {
  const [date, setDate] = React.useState(new Date());
  const [maxDate, setMaxDate] = React.useState(null);
  const [hourSchedule, setHourSchedule] = React.useState("00:00");
  const [hoursSchedule, setHoursSchedule] = React.useState([]);
  const [selectedDate, setSelectedDate] = React.useState(new Date());
  const [comments, setComments] = React.useState("");
  const [unavailableTimes, setUnavailableTimes] = React.useState([]);
  const [datesDisabled, setDatesDisabled] = React.useState({});
  const [daySelected, setDaySelected] = React.useState({});
  const [month, setMonth] = React.useState(null);
  const [showModal, setShowModal] = React.useState(false);
  const [company, setCompany] = React.useState({});
  const [service, setService] = React.useState(null);
  const [serviceSelected, setServiceSelected] = React.useState(null);
  const [services, setServices] = React.useState([]);
  // const toast = useToast();
  const [email, setEmail] = React.useState("");
  const [name, setName] = React.useState("");
  const [isInformation, setIsInformation] = React.useState(false);

  const getInfoService = async (idService) =>
    new Promise(async (resolve, reject) => {
      // console.log(idService);
      firebase
        .firestore()
        .collection("services")
        .doc(company.id)
        .collection("servicesList")
        .doc(idService)
        .get()
        .then((res) => {
          // console.log("aqui", res.data());
          resolve(res.data());
        });
    });

  React.useEffect(() => {
    getInfoService(serviceSelected).then((res) => {
      setService(res);
    });
    // console.log("mês", moment().tz("America/Sao_Paulo").format("M"));
    setMonth(moment().tz("America/Sao_Paulo").format("M"));
  }, [serviceSelected]);

  React.useEffect(() => {
    (async () => {
      let url = window.location.pathname;
      let uid = url.replace("/", "");
      // let info = await firebase.currentUser;

      // console.log(uid);
      if (uid !== null) {
        await firebase
          .firestore()
          .collection("companies")
          .doc(uid)
          .get()
          .then((res) => {
            // console.log(res.id);
            const obj = { id: res.id, ...res.data() };
            setCompany(obj);
          });
      }
      // };
      // init();
    })();
  }, []);

  React.useEffect(() => {
    (async () => {
      // console.log("entrou aqui");
      // console.log(company.id);
      if (company && company.id) {
        await firebase
          .firestore()
          .collection("services")
          .doc(company.id)
          .collection("servicesList")
          .get()
          .then((querySnapshot) => {
            // console.log("AQUIIII");

            const list = querySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));
            // console.log(list);
            // console.log(querySnapshot._data);
            setServices(list);
          });
      }
    })();
  }, [company]);

  // React.useEffect(() => {
  //   // date, hour, uidUser, timeSpent, description ---- OK
  //   // listar horários de 30 em 30 minutos de abertura e fechamento -- ok
  //   let markedDates = {};
  //   if (company && company.id) {
  //     var openingTimeMinutes = moment
  //       .duration(
  //         moment(company.openingTime, 'HH:mm')
  //           .tz('America/Sao_Paulo')
  //           .format('HH:mm'),
  //       )
  //       .asMinutes();

  //     var closingTimeMinutes = moment
  //       .duration(
  //         moment(company.closingTime, 'HH:mm')
  //           .tz('America/Sao_Paulo')
  //           .format('HH:mm'),
  //       )
  //       .asMinutes();

  //     selectTimes(
  //       openingTimeMinutes,
  //       closingTimeMinutes,
  //       setHoursSchedule,
  //       hoursSchedule,
  //     );
  //     if (
  //       isTimeBetween(
  //         moment().tz('America/Sao_Paulo').format('HH:mm').toString(),
  //         company.openingTime,
  //         company.closingTime,
  //       ) === false
  //     ) {
  //       markedDates[moment().tz('America/Sao_Paulo').format('YYYY-MM-DD')] = {
  //         disabled: true,
  //       };
  //     }

  //     setDatesDisabled({...datesDisabled, ...markedDates});

  //     var lunchStartTimeMinutes = moment
  //       .duration(
  //         moment(company.lunchStartTime, 'HH:mm')
  //           .tz('America/Sao_Paulo')
  //           .format('HH:mm'),
  //       )
  //       .asMinutes();

  //     var lunchEndTimeMinutes = moment
  //       .duration(
  //         moment(company.lunchEndTime, 'HH:mm')
  //           .tz('America/Sao_Paulo')
  //           .format('HH:mm'),
  //       )
  //       .asMinutes();

  //     selectTimes(
  //       Number(lunchStartTimeMinutes),
  //       Number(lunchEndTimeMinutes),
  //       setUnavailableTimes,
  //       unavailableTimes,
  //     );
  //   }
  // }, [service]);

  // React.useEffect(() => {
  //   if (month !== null) {
  //     console.log('test', month);
  //     const obj = {};
  //     var count = moment().month(month).daysInMonth();
  //     console.log(count);
  //     // var days = [];
  //     const monthCurrent = moment().tz('America/Sao_Paulo').format('M');
  //     console.log('MESES');
  //     console.log(monthCurrent, month);
  //     const dayCurrent =
  //       monthCurrent === month
  //         ? moment().tz('America/Sao_Paulo').format('D')
  //         : 1;
  //     // console.log('dia atual', dayCurrent);
  //     if (company && company.id && month >= monthCurrent) {
  //       for (var i = Number(dayCurrent); i < count + 1; i++) {
  //         // days.push(moment().month(month).date(i)  );

  //         console.log(i);
  //         console.log(
  //           moment()
  //             .month(month)
  //             .date(i)
  //             .tz('America/Sao_Paulo')
  //             .format('YYYY-MM-DD'),
  //         );
  //         // company.daysOfTheWeek.forEach(days => {
  //         obj[
  //           moment()
  //             .month(month)
  //             .date(i)
  //             .tz('America/Sao_Paulo')
  //             .format('YYYY-MM-DD')
  //         ] = {
  //           disableTouchEvent: !company.daysOfTheWeek.some(
  //             item =>
  //               item.value ==
  //               moment().tz('America/Sao_Paulo').month(month).date(i).day(),
  //           ),
  //           disabled: !company.daysOfTheWeek.some(
  //             item =>
  //               item.value ==
  //               moment().tz('America/Sao_Paulo').month(month).date(i).day(),
  //           ),
  //         };

  //         setDatesDisabled({...datesDisabled, ...obj});
  //       }
  //     }
  //   }
  // }, [month]);

  // React.useEffect(() => {
  //   const currentDate = moment().tz('America/Sao_Paulo').format('YYYY-MM-DD');
  //   const maxDate = moment(currentDate, 'YYYY-MM-DD').add('days', 30);
  //   setDate(currentDate);
  //   setMaxDate(maxDate);
  //   setSelectedDate(currentDate);

  //   const obj = {};
  //   obj[currentDate] = {
  //     selected: true,
  //     selectedColor: colors.dark,
  //   };

  //   setDaySelected(obj);
  // }, []);

  // React.useState(() => {
  //   if (company && company.id) {
  //     firebase.firestore()
  //       .collection('schedules')
  //       .doc(company.id)
  //       .collection('schedulesList')
  //       .onSnapshot(
  //         querySnapshot => {
  //           let arr = [];
  //           querySnapshot.forEach(snapshot => {
  //             let data = snapshot.data();
  //             arr.push(data);
  //           });

  //           const filterSchedules = arr.filter(
  //             info => info.date === selectedDate,
  //           );

  //           console.log('filterSchedules', filterSchedules.length);
  //           if (filterSchedules.length > 0) {
  //             filterSchedules.map(schedule => {
  //               // console.log('test_service', schedule.service);
  //               let scheduleHour = moment.duration(schedule.hour).asMinutes();
  //               let timeService =
  //                 Number(scheduleHour) + Number(schedule.service.timeSpent);

  //               selectTimes(
  //                 Number(scheduleHour),
  //                 Number(timeService),
  //                 setUnavailableTimes,
  //                 unavailableTimes,
  //               );
  //             });
  //           }
  //         },
  //         err => console.log(err),
  //       );
  //   }
  // }, [company.id]);

  // React.useEffect(() => {
  //   if (company && company.id) {
  //     firebase.firestore()
  //       .collection('schedules')
  //       .doc(company.id)
  //       .collection('schedulesList')
  //       .where(
  //         'date',
  //         '>=',
  //         moment().tz('America/Sao_Paulo').format('YYYY-MM-DD'),
  //       )
  //       .onSnapshot(
  //         querySnapshot => {
  //           let arr = [];
  //           querySnapshot.forEach(snapshot => {
  //             let data = snapshot.data();
  //             arr.push(data);
  //           });

  //           console.log('arr.length', arr.length);
  //           if (arr.length > 0) {
  //             arr.map(schedule => {
  //               let scheduleHour = moment.duration(schedule.hour).asMinutes();
  //               let timeService =
  //                 Number(scheduleHour) + Number(schedule.service.timeSpent);

  //               selectTimes(
  //                 Number(scheduleHour),
  //                 Number(timeService),
  //                 setUnavailableTimes,
  //                 unavailableTimes,
  //               );
  //             });
  //           }
  //         },
  //         err => console.log(err),
  //       );
  //   }
  // }, [company.id]);

  React.useEffect(() => {
    if (unavailableTimes && unavailableTimes.length > 0) {
      // console.log("TIRARRRR", unavailableTimes);

      var openingTimeMinutes = moment
        .duration(moment(company.openingTime, "HH:mm").format("HH:mm"))
        .asMinutes();

      var closingTimeMinutes =
        moment
          .duration(moment(company.closingTime, "HH:mm").format("HH:mm"))
          .asMinutes() - 30;

      const hoursSchedules = selectTimes(
        openingTimeMinutes,
        closingTimeMinutes,
        null
      );

      const sortedActivities = unavailableTimes.sort((a, b) => b - a);

      // console.log("HORASSSS", sortedActivities);

      var myArray = hoursSchedules.filter(
        (item) => !sortedActivities.includes(item)
      );

      const hoursFormatted = myArray.map((hour) => {
        const hourFormatted = moment(hour, "HH:mm")
          .add(service.timeSpent - 30, "minutes")
          .format("HH:mm")
          .toString();
        const hourFormattedMinutes = moment.duration(hourFormatted).asMinutes();

        const hourMinutes = moment
          .duration(moment(hour, "HH:mm").format("HH:mm"))
          .asMinutes();

        // console.log(
        //   'PARA REMOVER',
        //   moment
        //     .utc()
        //     .startOf('day')
        //     .add(hourFormattedMinutes, 'minutes')
        //     .format('HH:mm'),
        // );

        // console.log('PARA FICAR', hour);

        const intervalHours = selectTimes(
          hourMinutes,
          hourFormattedMinutes,
          null
        );

        // console.log('INTERVAL HOURSSS', intervalHours, myArray);

        const containsAll = intervalHours.every((element) => {
          return myArray.includes(element);
        });

        // console.log(containsAll);

        if (containsAll) return hour;
      });

      // console.log('HORÁRIOS DISPONÍVEIS', hoursFormatted);
      // console.log('horarios disp', hoursSchedule);
      // let availableTimes = hoursSchedule.filter(
      //   x => unavailableTimes.indexOf(x) == -1,
      // );

      // // console.log('horarios', hoursSchedule);
      // console.log('horarios indp', unavailableTimes);
      // console.log('horarios finais', availableTimes);

      // // const availableTimesM = availableTimes.filter(
      //   availableTime =>
      //     availableTimes.indexOf(
      //       moment(availableTime, 'HH:mm')
      //         .add(service.timeSpent, 'minutes')
      //         .format('HH:mm'),
      //     ) == -1,
      // );

      const results = hoursFormatted.filter((element) => {
        return element !== undefined;
      });

      setHoursSchedule(results);
    } else {
      var openingTimeMinutes = moment
        .duration(moment(company.openingTime, "HH:mm").format("HH:mm"))
        .asMinutes();

      var closingTimeMinutes = moment
        .duration(moment(company.closingTime, "HH:mm").format("HH:mm"))
        .asMinutes();

      const hoursSchedules = selectTimes(
        openingTimeMinutes,
        closingTimeMinutes,
        null
      );
      setHoursSchedule(hoursSchedules);
    }
  }, [unavailableTimes]);

  const verifyHours = (day) => {
    setUnavailableTimes([]);

    var indisposibles = [];

    // var lunchStartTimeMinutes = moment
    //   .duration(moment(company.lunchStartTime, 'HH:mm').format('HH:mm'))
    //   .asMinutes();

    // console.log('lunchStartTimeMinutes', lunchStartTimeMinutes);

    // var lunchEndTimeMinutes = moment
    //   .duration(
    //     moment(company.lunchEndTime, 'HH:mm')
    //       // .add(Number(service.timeSpent + 30), 'minutes')
    //       .format('HH:mm'),
    //   )
    //   .asMinutes();

    // console.log('lunchEndTimeMinutes', lunchEndTimeMinutes);

    // const returnUnavailableTimes = selectTimes(
    //   Number(lunchStartTimeMinutes),
    //   Number(lunchEndTimeMinutes) - 30,
    //   null,
    // );

    // console.log(unavailableTimes, returnUnavailableTimes);
    // const arrayy = unavailableTimes.concat(returnUnavailableTimes);
    // setUnavailableTimes(arrayy);

    // console.log('vishhh', arrayy);

    // indisposibles = returnUnavailableTimes;

    // if (hoursSchedule.length > 0) {
    //   var filtered = hoursSchedule.filter(hour => {
    //     console.log('caiu aqui, ufa');
    //     const hourFormatted = moment(hour, 'HH:mm')
    //       .add(service.timeSpent, 'minutes')
    //       .format('HH:mm');
    //     // const hourFormattedMinutes = moment.duration(hourFormatted).asMinutes();
    //     // console.log('AQUIIII', hoursSchedule);
    //     // console.log(
    //     //   'AQUIIII2',
    //     //   hourFormatted,
    //     //   hoursSchedule.includes(hourFormatted.toString()),
    //     // );
    //     if (hoursSchedule.includes(hourFormatted.toString()) === false) {
    //       return hourFormatted;
    //     }
    //   });
    //   console.log('aquiiii', filtered);

    //   var myArray = hoursSchedule.filter(item => !filtered.includes(item));

    //   setHoursSchedule(myArray);
    // }

    firebase
      .firestore()
      .collection("schedules")
      .doc(company.id)
      .collection("schedulesList")
      .onSnapshot(
        (querySnapshot) => {
          let arr = [];
          querySnapshot.forEach((snapshot) => {
            let data = snapshot.data();
            arr.push(data);
          });

          const filterSchedules = arr.filter((info) => info.date === day);

          filterSchedules.map((schedule) => {
            let scheduleHour = moment.duration(schedule.hour).asMinutes();
            let timeService =
              Number(scheduleHour) + Number(schedule.service.timeSpent);

            // console.log('debug');
            // console.log(scheduleHour);
            // console.log(timeService);

            const returnUnavailableTimess = selectTimes(
              Number(scheduleHour),
              Number(timeService),
              null
            );

            // const array = indisposibles.concat(returnUnavailableTimess);
            // console.log('vishhh111', array);
            // setUnavailableTimes(array);

            indisposibles = returnUnavailableTimess;

            // console.log("HORÁRIOS INDISPONÍVEIS", indisposibles);

            setUnavailableTimes(indisposibles);
          });
        },
        (err) => console.log(err)
      );

    // console.log("HORÁRIOS INDISPONÍVEIS", indisposibles);

    setUnavailableTimes(indisposibles);
  };

  const selectTimes = (firstTime, lastTime, setState, state) => {
    var arr = [];
    // console.log('null', firstTime - 30, lastTime + 30);
    let first = firstTime;
    let last = lastTime;
    while (first <= last) {
      // console.log(first);
      var duration = moment
        .utc()
        .startOf("day")
        .add(first, "minutes")
        .format("HH:mm");

      first += 30;
      arr.push(duration);
    }

    return arr;
  };

  const addSchedule = () => {
    const tel = email
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");
    const obj = {
      date: moment(selectedDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
      hour: hourSchedule,
      comments,
      company,
      service: service,
      user: {
        name,
        email: tel,
        uid: null,
      },
      isLink: true,
    };

    if (
      selectedDate === null ||
      hoursSchedule === null ||
      name === "" ||
      email === "" ||
      company === "" ||
      service === ""
    ) {
      // toast.show({
      //   title: "Campos obrigatórios",
      //   status: "warning",
      //   description: "Por favor, preencha todos os campos obrigatórios",
      // });
      alert(
        "Campos obrigatórios",
        "Por favor, preencha todos os campos obrigatórios"
      );
    } else {
      firebase
        .firestore()
        .collection("schedules")
        .doc(company.id)
        .collection("schedulesList")
        .add(obj)
        .then((res) => {
          // console.log("agendamento criado com sucesso!");
          // toast.show({
          //   description:
          //     "",
          // });
          // alert("Agendamento realizado com sucesso! O salão irá confirmar.");
          setIsInformation(true);

          // navigation.navigate("HomeProfessional");

          // TODO se o usuário tiver o email cadastrado e for active == true vincula o agendamento a ele e envia notificação

          // obj.idScheduleCompany = res.id;
          // delete obj.user;
          // firebase.firestore()
          //   .collection('users')
          //   .doc(company.id)
          //   .collection('schedules')
          //   .add(obj)
          //   .then(() => {
          //     console.log('agendamento vinculado ao usuário!');
          //     toast.show({
          //       description: 'Agendamento realizado com sucesso!',
          //     });

          //     // }, 3000);
          //   })
          //   .catch(err => console.log(err));
        })
        .catch((err) => console.log(err));
    }
  };

  const Information = () => {
    return (
      <Box
        alignItems="center"
        p={4}
        m={3}
        shadow={5}
        backgroundColor={colors.gray}
        borderRadius={5}
      >
        <Text
          fontFamily={fonts.bold}
          fontSize={fontsSize.lg}
          textAlign="center"
          mb={3}
        >
          Agendamento realizado!
        </Text>
        <Text
          fontFamily={fonts.bold}
          fontSize={fontsSize.md}
          fontWeight="bold"
          textAlign="center"
          mb={2}
        >
          Anote as informações abaixo
        </Text>
        <Text
          fontFamily={fonts.lg}
          fontSize={fontsSize.md}
          textAlign="center"
          mb={3}
        >
          Dia {moment(selectedDate, "DD-MM-YYYY").format("DD-MM-YYYY")} às{" "}
          {hourSchedule}
        </Text>
        <Text
          fontFamily={fonts.medium}
          fontSize={fontsSize.md}
          textAlign="center"
        >
          Em caso de dúvidas, entre em contato com o salão.
        </Text>
        <Text
          fontFamily={fonts.bold}
          fontSize={fontsSize.lg}
          textAlign="center"
        >
          {company.phone}
        </Text>
      </Box>
    );
  };

  if (isInformation) return <Information />;

  return (
    <>
      <Text
        p={5}
        style={{
          borderBottomLeftRadius: "50px",
          borderBottomRightRadius: "50px",
          boxShadow: "10px 5px 20px black",
        }}
        textAlign="center"
        color={colors.white}
        fontSize={fontsSize.lg}
        fontFamily={fonts.medium}
        backgroundColor={colors.dark}
      >
        {company.company}
      </Text>

      <Text p={2} fontFamily={fonts.bold} mt={8} fontSize={fontsSize.md} fontWeight="bold">
        Preencha os campos abaixo para realizar o agendamento
      </Text>
      <FormControl p={2}>
        <Text fontFamily={fonts.bold}>Informe o seu nome</Text>
        <Input onChange={(e) => setName(e.target.value)} value={name} />
        <Text fontFamily={fonts.bold}>
          Informe seu WhatsApp (Necessário em caso de cancelamento)
        </Text>

        <InputMask
          // style={{ color: "#000" }}
          mask="(99) 99999-9999"
          value={email}
          style={{
            width: "inherit",
            border: "1px solid #e2e8f0",
            borderRadius: "5px",
          }}
          textColor={colors.black}
          onChange={({ target: { value } }) => setEmail(value)}
        >
          {(inputProps) => (
            <MaterialInput color={colors.black} {...inputProps} type="tel" />
          )}
        </InputMask>
        {/* </InputMask>

        {/* <Input onChange={(e) => setEmail(e.target.value)} value={email} /> */}

        <>
          <Text fontFamily={fonts.bold}>Informe o serviço</Text>
          {services.length > 0 ? (
            <Select
              onChange={(e) => setServiceSelected(e.target.value)}
              // mb={1}
              // selectedValue={serviceSelected}
              // minWidth="200"
              // placeholder="Informe o serviço"
              // _selectedItem={{
              //   bg: "teal.600",
              //   endIcon: <CheckIcon size="5" />,
              // }}
              // mt={1}
              // onValueChange={(itemValue) => setServiceSelected(itemValue)}
            >
              <option value="">Selecione...</option>
              {services.length > 0 &&
                services.map((info, i) => (
                  // <Select. label={info.title} value={info.id} />
                  <option value={info.id}>{info.title}</option>
                ))}
            </Select>
          ) : (
            ""
          )}
        </>

        {serviceSelected !== null && (
          <>
            <Text mb={3} mt={5} fontFamily={fonts.bold}>
              Escolha uma data e horário para agendar
            </Text>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Calendar
                minDate={new Date()}
                datesDisabled={[moment()]}
                // formatDay={(date) =>
                //   new Intl.DateTimeFormat({
                //     year: "numeric",
                //     month: "2-digit",
                //     day: "2-digit",
                //   }).format(date)
                // }
                onChange={(date) => {
                  // console.log("date selected", date);
                  setSelectedDate(date);

                  const obj = {};
                  obj[moment(date, "YYYY-MM-DD").format("YYYY-MM-DD")] = {
                    selected: true,
                    selectedColor: colors.dark,
                  };

                  setDaySelected(obj);
                  verifyHours(moment(date, "YYYY-MM-DD").format("YYYY-MM-DD"));

                  // setSelectedDate(
                  //   moment(e.target.value, "YYYY-MM-DD").format("YYYY-MM-DD")
                  // );
                }}
                value={selectedDate}
              />
            </div>
            <div style={{ marginTop: 10, marginBottom: 4 }}>
              <Text mb={3} mt={5} fontFamily={fonts.bold}>
                Veja os horários disponíveis
              </Text>
              <Select
                // mb={4}
                // selectedValue={hourSchedule}
                // minWidth="200"
                // placeholder="Exemplo: 17:00"
                // _selectedItem={{
                //   bg: "teal.600",
                //   endIcon: <CheckIcon size="5" />,
                // }}
                // mt={1}
                onChange={(e) => setHourSchedule(e.target.value)}
                // onValueChange={(itemValue) => setHourSchedule(itemValue)}
              >
                <option value="">Selecione...</option>
                {hoursSchedule &&
                  hoursSchedule.map((time) => (
                    // <Select.Item label={time} value={time} />
                    <option value={time}>{time}</option>
                  ))}
              </Select>
              <Text mb={3} mt={5}>
                Tem alguma observação? Digite abaixo!
              </Text>
              <Input
                onChange={(e) => setComments(e.target.value)}
                value={comments}
                height={100}
                borderColor={colors.gray600}
              />
            </div>
            <Button
              onClick={addSchedule}
              width="full"
              mt={3}
              textColor={colors.white}
              backgroundColor={colors.dark}
            >
              Finalizar Agendamento
            </Button>
          </>
        )}
      </FormControl>
    </>
  );
};

export default CreateSchedule;
